import * as React from 'react';
import cx from 'classnames';

import styles from './style.module.scss';

interface BadgeProps {
  children: any;
  className?: string;
  style?: any;
}

export default function Badge({ children, className, style }: BadgeProps) {
  return (
    <span className={cx(styles.badgeContainer, className)} style={style}>
      {children}
    </span>
  );
}

export const DefaultBadge = (props: BadgeProps) => {
  return <Badge {...props} className={cx('bg-gray-light', props.className)} />
};

export const InfoBadge = (props: BadgeProps) => {
  return <Badge {...props} className={cx(styles.bgInfo, props.className)} />
};

export const SuccessBadge = (props: BadgeProps) => {
  return <Badge {...props} className={cx(styles.bgSuccess, props.className)} />
};

export const WarningBadge = (props: BadgeProps) => {
  return <Badge {...props} className={cx(styles.bgWarning, props.className)} />
};

export const DangerBadge = (props: BadgeProps) => {
  return <Badge {...props} className={cx(styles.bgDanger, props.className)} />
};
